import { PagedSingleSelectField, laravelSelectFetchConfig, withOptionsEndpoint } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ContactAttributeOptionResource } from "../shared/types";

interface Props {
	name: string;
	label: string;
	infoText?: string;
	required?: boolean;
	disabled?: boolean;
}

const service = withOptionsEndpoint<ContactAttributeOptionResource>(["contact-attributes"]);

export const ContactAttributeSingleSelectField: FC<Props> = (props) => {
	const { t } = useTranslation();
	const [{ value: contactView }] = useField("defaultContactView");

	return (
		<PagedSingleSelectField
			{...props}
			fetchConfig={laravelSelectFetchConfig(service.optionsKey.concat(`${contactView.id}`), (search, page) =>
				service.options(search, page, { contactViewId: contactView.id }).then((r) => r.data),
			)}
			getLabel={(o) => (o.type === "dataField" ? o.name : t(`${o.name}`))}
			clearable={true}
		/>
	);
};
